import { SERVER_LINK } from "./ServerConstants";

export const NEW_INDIVIDUAL_REGISTRATION_API_CONSTANT = `${SERVER_LINK}/v1/individual-event`;

export const NEW_TEAM_REGISTRATION_API_CONSTANT = `${SERVER_LINK}/v1/team-event`;

export const GET_ALL_INDIVIDUAL_REGISTRATIONS_API_CONSTANT = `${SERVER_LINK}/v1/individual-event`;

export const GET_ALL_TEAM_REGISTRATIONS_API_CONSTANT = `${SERVER_LINK}/v1/team-event`;

export const GET_REGISTRATIONS_COUNT_API_CONSTANT = `${SERVER_LINK}/v1/statistics`
